<template>
  <div class="reset-password">
    <div class="row">
      <div class="col-md-12">
        <div
          class="form-group row"
          :class="{'has-error' : validations.old_password}"
        >
          <label
            for="email"
            class="col-md-4 col-form-label text-md-right"
          >{{ $t('label.oldPassword') }}</label>
          <div class="col-md-6">
            <input
              id="email"
              v-model="user.old_password"
              type="password"
              :placeholder="$t('label.oldPassword')"
              class="form-control"
              name="email"
              autofocus
            >
            <template v-if="validations.old_password">
              <FiledIsRequired :msg="validations['old_password'][0]" />
            </template>
          </div>
        </div>

        <div
          class="form-group row"
          :class="{'has-error' : validations.password}"
        >
          <label
            for="password"
            class="col-md-4 col-form-label text-md-right"
          >{{ $t('label.password') }}</label>
          <div class="col-md-6">
            <input
              id="password"
              v-model="user.password"
              type="password"
              :placeholder="$t('label.password')"
              class="form-control"
              name="password"
            >
            <template v-if="validations.password">
              <FiledIsRequired :msg="validations['password'][0]" />
            </template>
          </div>
        </div>

        <div
          class="form-group row"
          :class="{'has-error' : validations.password}"
        >
          <label
            for="password-confirm"
            class="col-md-4 col-form-label text-md-right"
          >{{ $t('label.confirmPassword') }}</label>
          <div class="col-md-6">
            <input
              id="password-confirm"
              v-model="user.password_confirmation"
              type="password"
              :placeholder="$t('label.confirmPassword')"
              class="form-control"
              name="password_confirmation"
            >
            <template v-if="validations.password">
              <FiledIsRequired :msg="validations['password'][0]" />
            </template>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-4" />
          <div class="col-md-6">
            <button
              type="submit"
              class="btn btn-primary"
              @click="resetPassword"
            >
              {{ $t('button.resetPassword') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FiledIsRequired from '@/components/FiledIsRequired'

export default {
  name: 'ResetPassword',
  components: { FiledIsRequired },
  data () {
    return {
      user: {
        password: null,
        old_password: null,
        password_confirmation: null
      },
      validations: {}
    }
  },
  methods: {
    resetPassword () {
      this.validations = {}
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/auth/backend/reset-password', this.user)
        .then(({ data }) => {
          if (data.data) {
            const {
              access_token,
              refresh_token
            } = data.data

            localStorage.setItem(this.$token, access_token)
            localStorage.setItem(process.env.VUE_APP_REFRESH_TOKEN, refresh_token)

            this.$axios.defaults.headers.common.Authorization = 'Bearer ' + access_token
            $.ajaxSetup({
              headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + access_token
              }
            })
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    }
  }
}
</script>

<style scoped>
  .reset-password {
    padding: 10px;
  }

  .text-md-right {
    text-align: right;
  }
</style>
